import { h, resolveComponent } from 'vue'

const ListadoSaldo = () => import('@/app/views/saldo/views/ListadoSaldo');


const saldoRoutes = [
  {
    path: 'saldo',
    name: 'Saldo',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      }
    },
    children: [
      {
        path: '',
        name: 'saldo:Listado',
        component: ListadoSaldo,
        meta: {
          auth: true,
          entidad: 'saldo'
        },
      }
    ]
  }
];

export default saldoRoutes;
